import { gql } from '@/__generated__';

export const ADD_DEVICE_TAG = gql(`#graphql
  mutation AddDeviceTag($input: AddDeviceTagInput!) {
    addDeviceTag(input: $input) {
      device {
        id
        profile {
          id
          tags {
            tag
            attributes
          }
        }
      }
    }
  }
`);
